import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/contact/personal_group.svg';
const PersonalGroup = () => React.createElement(IconSvg, null);
export default PersonalGroup;
